import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const IncidentTypesRedux = createActions(
  {
    // Custom actions
  },
  {
    prefix: 'INCIDENT_TYPES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = IncidentTypesRedux
export const IncidentTypesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
},
{
  get: true,
  // Default state
})

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/IncidentTypes.js